export default __webpack_public_path__ + "static/cookfox-2f136b0c6df17a6eebc992aefc62e0fa.svg";